import React, { useEffect, useRef, useState } from "react";
import "./styles/LoginForm.css";

export default function LoginForm({ setUser }) {
  const [form, setForm] = useState({ username: "", password: "" });
  const [token, setToken] = useState("");
  const [error, setError] = useState("");
  const [mfaStep, setMfaStep] = useState(false);
  const [verifying, setVerifying] = useState(false);

  const mfaInputRef = useRef(null);

  useEffect(() => {
    if (mfaStep) {
      // ensures the input exists in the DOM before focusing
      requestAnimationFrame(() => mfaInputRef.current?.focus());
    }
  }, [mfaStep]);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");

    const res = await fetch("/api/login.php", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "include",
      body: JSON.stringify(form),
    });

    const data = await res.json();

    if (res.ok && data.user) {
      setUser(data.user);
    } else if (res.ok && data.mfa_required) {
      setMfaStep(true);
    } else {
      setError(data.error || "Connection failed");
    }
  };

  const handleVerify = async (e) => {
    e.preventDefault();
    setVerifying(true);
    setError("");

    const res = await fetch("/api/mfa_verify_token.php", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "include",
      body: JSON.stringify({
        token,
        username: form.username,
        password: form.password,
      }),
    });

    const data = await res.json();

    if (res.ok && data.success) {
      const userRes = await fetch("/api/me.php", { credentials: "include" });
      const userData = await userRes.json();
      setUser(userData.user);
    } else {
      setError(data.error || "Incorrect MFA code");
    }

    setVerifying(false);
  };

  return (
    <div
      className="d-flex justify-content-center align-items-center login-wrapper"
      style={{ minHeight: "100vh", backgroundColor: "#1a1a1a" }}
    >
      <div
        className="shadow-lg p-4"
        style={{
          backgroundColor: "#1e1e1e",
          border: "1px solid #2b2b2b",
          borderRadius: "10px",
          width: "100%",
          maxWidth: "400px",
        }}
      >
        <div className="text-center mb-4">
          <img
            src="/img/logo_test6.png"
            alt="CIRFlask Logo"
            style={{ width: "48px", height: "48px", filter: "brightness(1.5)" }}
            className="mb-2"
          />
          <h3 className="fw-bold" style={{ color: "#c77a3a", fontFamily: "Segoe UI, sans-serif" }}>
            CIRFlask
          </h3>
        </div>

        {!mfaStep ? (
          <form onSubmit={handleLogin}>
            <div className="mb-3">
              <input
                type="text"
                name="username"
                placeholder="Username"
                autoComplete="off"
                value={form.username}
                onChange={handleChange}
                className="form-control bg-dark text-light border border-secondary"
                autoFocus
                required
              />
            </div>

            <div className="mb-3">
              <input
                type="password"
                name="password"
                placeholder="Password"
                autoComplete="off"
                value={form.password}
                onChange={handleChange}
                className="form-control bg-dark text-light border border-secondary"
                required
              />
            </div>

            <button
              type="submit"
              className="btn w-100 fw-bold"
              style={{
                backgroundColor: "#c77a3a",
                color: "#fff",
                border: "none",
                transition: "all 0.2s ease-in-out",
              }}
              onMouseOver={(e) => (e.target.style.backgroundColor = "#af5d21")}
              onMouseOut={(e) => (e.target.style.backgroundColor = "#c77a3a")}
            >
              Sign in
            </button>
          </form>
        ) : (
          <form onSubmit={handleVerify}>
            <div className="mb-3">
              <input
                ref={mfaInputRef}
                type="text"
                name="token"
                placeholder="6-digit MFA code"
                autoComplete="one-time-code"
                inputMode="numeric"
                pattern="[0-9]{6}"
                maxLength={6}
                value={token}
                onChange={(e) => setToken(e.target.value.replace(/\D/g, "").slice(0, 6))}
                className="form-control bg-dark text-light border border-secondary"
                required
              />
            </div>

            <button
              type="submit"
              disabled={verifying || token.length !== 6}
              className="btn w-100 fw-bold"
              style={{
                backgroundColor: "#c77a3a",
                color: "#fff",
                border: "none",
                transition: "all 0.2s ease-in-out",
              }}
              onMouseOver={(e) => (e.target.style.backgroundColor = "#af5d21")}
              onMouseOut={(e) => (e.target.style.backgroundColor = "#c77a3a")}
            >
              Verify code
            </button>
          </form>
        )}

        {error && (
          <div className="alert alert-danger mt-3 text-center py-2 mb-0">
            <i className="bi bi-exclamation-triangle me-2"></i>
            {error}
          </div>
        )}
      </div>
    </div>
  );
}